import { atom } from 'jotai';

export const cardHolderNameAtom = atom<string | null>(null);
